import { DataCard } from "components/common/DataCard";
import {
  NUMBERS,
  SITE_DOWN_HEADER,
  SITE_DOWN_MESSAGE_1,
  SITE_DOWN_MESSAGE_2,
} from "./SiteDown.const";
import { SiteDownPastRepaymentDateMessage } from "./SiteDownPastRepaymentDateMessage";
import { brand } from "services/envService";
import { SITE_DOWN_TITLE } from "screens/Title.const";
import { Heading, HeadingTag } from "components/common/Heading";
import { Nullable } from "util/extendedTypes";

const BRAND = brand();

export type SiteDownProps = {
  message?: Nullable<string>;
};

export const SiteDown = ({ message = null }: SiteDownProps) => {
  const isInvalidFinalRepayment = message?.includes(
    "finalRepaymentDate is invalid"
  );
  document.title = SITE_DOWN_TITLE;
  return (
    <div className="appendix-wrapper">
      {isInvalidFinalRepayment ? null : (
        <Heading
          tag={HeadingTag.h1}
          size={1}
          className="zb-heading1 screen-header"
          title={SITE_DOWN_HEADER}
        />
      )}

      <DataCard>
        <span>
          {isInvalidFinalRepayment ? (
            <SiteDownPastRepaymentDateMessage />
          ) : (
            <>
              {SITE_DOWN_MESSAGE_1} <b>{NUMBERS[BRAND]}</b>
              {". "}
              <span className="appendix-awareness">{SITE_DOWN_MESSAGE_2}</span>
            </>
          )}
        </span>
      </DataCard>
    </div>
  );
};
